import script from "./process_print_warranty.vue?vue&type=script&setup=true&lang=js"
export * from "./process_print_warranty.vue?vue&type=script&setup=true&lang=js"

import "./process_print_warranty.vue?vue&type=style&index=0&id=21efb7ae&lang=css"

const __exports__ = script;

export default __exports__